import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 3a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2z","key":"svg-0"}],["path",{"d":"M9 18h6","key":"svg-1"}]]

const IconDeviceIpad = createReactComponent('outline', 'device-ipad', 'DeviceIpad', __iconNode);

export default IconDeviceIpad;